// src/services/authService.js
import axios from 'axios';
import { showInfo } from './toastService';
import { Navigate } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + 'devices/'; // Replace with your actual API base URL

const apiService = axios.create({
    baseURL: API_BASE_URL,
});

// Add a request interceptor to include the token in headers for authenticated requests
apiService.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Define CRUD operations

// Create
export const createDevice = async (data) => {
    try {
        // console.log(data)
        const response = await apiService.post('/', data);
        return response;
    } catch (error) {
        throw error.response.data;
    }
};


export const getDevice = async (filter) => {
    try {
        const params = new URLSearchParams(filter).toString();
        const response = await apiService.get(`/?${params}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getDeviceDetails = async (device_id, type) => {
    try {
        //const params = new URLSearchParams(filter).toString();
        const response = await apiService.get(`data/devicesDetails?id=${device_id}&type=${type}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};


export const getDeviceDataByID = async (device_id, date) => {
    try {
        //const params = new URLSearchParams(filter).toString();
        const response = await apiService.get(`data/devicesData?id=${device_id}&date=${date}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 403) {
            // Call your logout function or perform logout logic
            logout();
            // Optionally, you can throw an error or return a specific message
            throw new Error("Unauthorized access, user logged out.");
        }
        throw error.response.data;
    }
};


export const getDeviceById = async (id) => {
    try {
        const response = await apiService.get(`${id}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getExportDeviceById = async (id, start, end) => {
    try {
        const response = await apiService.get(`data/devicesExportData?id=${id}&sdate=${start}&edate=${end}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

// Update
export const updateDevice = async (itemId, data) => {
    try {
        const response = await apiService.put(`/${itemId}`, data);
        return response;
    } catch (error) {
        throw error.response.data;
    }
};

// Delete
export const deleteDevice = async (itemId) => {
    try {
        const response = await apiService.delete(`/${itemId}`);
        return response;
    } catch (error) {
        throw error.response.data;
    }
};

// Example logout function
const logout = () => {
    showInfo('Session timeout.')
    // Clear user session or token
    localStorage.removeItem('token'); // Remove the token
    // Redirect to login page or perform any other logout actions
    Navigate('/login');
};

export default apiService;



